import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { COPIES_PREFIX } from '../../constants';
import classes from './SellerNameDisplay.module.scss';

interface SellerNameDisplayProps {
  sellerUserName: string;
  onClick: () => void;
}

export const SellerNameDisplay = ({ sellerUserName, onClick }: SellerNameDisplayProps) => {
  const hrefToSeller = pathfinder('seller_page', { username: sellerUserName });
  const sellerNameLabelCopy = `${COPIES_PREFIX}.by_seller`;
  return (
    <I18n
      k={sellerNameLabelCopy}
      params={{ sellerUserName }}
      templates={{
        link: (text) => (
          <a
            className={classnames(classes.seller, 'text-semi-bold')}
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            href={hrefToSeller}
          >
            {text}
          </a>
        ),
      }}
    />
  );
};
